import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { ensureHttps } from '@/shared/lib/website';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(date: string | Date): string {
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function toDatetimeLocalValue(iso: string | null | undefined): string {
  if (!iso) {
    return '';
  }

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function getFullName(user: { firstName?: string | null; lastName?: string | null } | null): string {
  if (!user) return '';
  const parts = [user.firstName, user.lastName].filter(Boolean);
  return parts.join(' ') || '';
}


/**
 * A website as a reader identifies it: host and path, no scheme, no `www.`.
 *
 * The path stays because a bare host is not always the record — 851 tools sit
 * on `woocommerce.com/products/<name>` and would otherwise render as the same
 * line. Anything unparseable is shown as stored rather than dropped.
 */
export function displayUrl(website: string): string {
  try {
    const url = new URL(ensureHttps(website));
    const path = url.pathname.replace(/\/$/, '');
    return `${url.host.replace(/^www\./, '')}${path}`;
  } catch {
    return website;
  }
}
